import React, { useState, useContext } from "react";
import classnames from "classnames";
import Styles from "./TypesOfLorries.module.scss";
import { AppContext } from "@vahak/core/dist/app-context";
import Link from "next/link";
import { useTranslation } from "next-i18next";

//Icons
import ArrowRightWhite from "@vahak/core/dist/icons/arrow-right-white.svg";
import AppImg from "components/utils/AppImg";
import { ga4sendEvent } from "@vahak/core/dist/_services/user-analytics.service";
import { GA4EventNames, GA4ServicePageOnlineTruckBookingEventValues } from "@vahak/core/dist/constants/event-names";

interface TypesOfLorresProps {
    lorryTypes: any;
    sectionTitle: string;
    sectionText: string;
}

interface DataProps {
    id: number;
    type: string;
    description: string;
    srcset: string;
    image: string;
    btnURL: string;
    odc: any;
    count: string;
    topStates: any;
    altText: string;
}

interface TopStateProps {
    srcset: string;
    image: string;
    state: string;
}

const TypesOfLorries = ({ lorryTypes, sectionTitle, sectionText }: TypesOfLorresProps) => {
    const { isMobile } = useContext(AppContext);
    const [isActive, setisActive] = useState(0);
    const { t } = useTranslation("servicePages");

    const handleIsActive = (e: number) => {
        setisActive(e);
    };

    return (
        <section className={Styles.main}>
            <div className={classnames(Styles.conainer, "container")}>
                <div className={Styles.heading}>
                    <h2>{sectionTitle}</h2>
                    <p>{sectionText}</p>
                </div>
                <div className={Styles.lorryTypesBox}>
                    <div className={Styles.lorryTypesNav}>
                        <ul>
                            {lorryTypes.map((data: DataProps) => (
                                <li
                                    className={isActive === data.id ? Styles.active : ""}
                                    onClick={() => handleIsActive(data.id)}
                                    key={data.id}
                                >
                                    {data.type}
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className={Styles.lorryTypeCardWrap}>
                        {lorryTypes.map((data: DataProps) => (
                            <div
                                className={classnames(Styles.lorryTypeCard, isActive === data.id ? Styles.active : "")}
                                key={data.id}
                            >
                                <div className={Styles.lorryImage}>
                                    <div className={Styles.imgBox}>
                                        <AppImg
                                            width={isMobile ? "230" : "755"}
                                            height={isMobile ? "148" : "460"}
                                            layout="responsive"
                                            src={data.image}
                                            alt={data.altText}
                                        />
                                    </div>
                                </div>
                                <div className={Styles.lorryText}>
                                    <h3>{data.type}</h3>
                                    {/* <p>{data.description}</p> */}
                                    <h4 className={Styles.count}>{data.count}</h4>
                                    <span className={Styles.label}>
                                        {t("servicePages:online-truck-booking.TypesOfLorries.number-of")} {data.type}{" "}
                                        {t("servicePages:online-truck-booking.TypesOfLorries.on-Vahak")}
                                    </span>
                                    {/* <ul>
                                        {data.odc.map((odc: string) => (
                                            <li>{odc}</li>
                                        ))}
                                    </ul> */}

                                    <div className={Styles.topStateRow}>
                                        {data.topStates &&
                                            data.topStates.map((topState: TopStateProps, index: number) => (
                                                <div className={Styles.stateCol} key={index}>
                                                    <div className={Styles.stateCard}>
                                                        <AppImg
                                                            sizes="(min-width: 992px) 170px, 100px"
                                                            width={isMobile ? "100" : "170"}
                                                            height={isMobile ? "79" : "134"}
                                                            src={topState.image}
                                                            alt={topState.state}
                                                        />
                                                        <h5>{topState.state}</h5>
                                                    </div>
                                                </div>
                                            ))}
                                    </div>

                                    <span className={Styles.label}>
                                        {t("servicePages:online-load-booking.TypesOfLoads.top-locations-for")}{" "}
                                        {data.type}
                                    </span>
                                    <div className={Styles.bookBtnWrapper}>
                                        <Link href={data.btnURL}>
                                            <a
                                                target="_blank"
                                                onClick={() => {
                                                    ga4sendEvent(GA4EventNames.Servicepage_online_truck_booking, {
                                                        value: GA4ServicePageOnlineTruckBookingEventValues.book_lorries
                                                    });
                                                }}
                                            >
                                                {t("servicePages:online-truck-booking.TypesOfLorries.book")} {data.type}{" "}
                                                {t("servicePages:online-truck-booking.TypesOfLorries.now")}
                                                <ArrowRightWhite />
                                            </a>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TypesOfLorries;
